export const appleDevice = !!navigator.platform?.match(/(Mac|iPhone|iPod|iPad)/i)
